import { ReactNode } from "react";
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import { StepInstrumentType, StepOptionOrderType, StepOrderSide } from "src/Interfaces/stepInterfaces";
import "./OrderPreviewInstrument.css";

export type PreviewInstrumentOption = DropdownItem & { type?: StepInstrumentType };

export const PreviewInstrumentHeader = ({ children }: { children: ReactNode }) => <>
  {children}
  <span className="order-preview-instrument-hint">جهت / نوع معامله</span>
</>;

const OrderPreviewInstrument = ({ name, orderSide, optionOrderType, instrumentType }: {
  name: string | null | undefined;
  orderSide: StepOrderSide | null | undefined;
  optionOrderType?: number | null;
  instrumentType?: StepInstrumentType;
}) => {
  const side = orderSide === StepOrderSide.Buy ? "خرید" : orderSide === StepOrderSide.Sell ? "فروش" : "—";
  const optionType = instrumentType === StepInstrumentType.Option
    ? optionOrderType === StepOptionOrderType.Offset ? "Offset" : optionOrderType === StepOptionOrderType.Open ? "Open" : null
    : null;

  return <div className="order-preview-instrument">
    <div className="order-preview-instrument-name">{name || "—"}</div>
    <div className="order-preview-instrument-details">
      <span className={orderSide === StepOrderSide.Buy ? "text-green-600" : orderSide === StepOrderSide.Sell ? "text-red-700" : undefined}>{side}</span>
      {optionType ? <><span aria-hidden="true">·</span><span dir="ltr">{optionType}</span></> : null}
    </div>
  </div>;
};

export default OrderPreviewInstrument;
